/* RESPONSIBLE TEAM: team-proactive-support */
import { stateChangeReasons } from 'embercom/models/data/matching-system/matching-constants';

export function exceededElasticSearchLimit(reason: number) {
  return reason === stateChangeReasons.exceededElasticSearchLimit;
}
